import React from 'react';
import { Audio } from 'svg-loaders-react'

import Box from './Box';

const Loading = (props) => (
  <Box {...props}>
    <Audio
      width="100%"
      height="auto"
      fill="currentColor"
    />
  </Box>
);

Loading.defaultProps = {
  color: 'primary',
  width: '4em',
};

export default Loading;
